import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import Modal from '../Modal/Modal';
import Swal from 'sweetalert2';
import '../Pricelist/Pricelist.css';
import {FaRuler} from 'react-icons/fa'; 
import { GiShop } from "react-icons/gi";

const Pricelist = () => {
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({ name: '', email: '', mobile: '', query: '' });
  const [formErrors, setFormErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submissionError, setSubmissionError] = useState('');

  const handleShowModal = () => setShowModal(true);
  const hideModal = () => setShowModal(false);

  const validate = (name, value) => {
    let errors = { ...formErrors };

    switch (name) {
      case 'name':
        errors.name = /^[A-Za-z\s]+$/.test(value) ? '' : 'Name should contain only alphabets.';
        break;
      case 'email':
        errors.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? '' : 'Invalid email address.';
        break;
      case 'mobile':
        errors.mobile = /^\d{10}$/.test(value) ? '' : 'Mobile number should be 10 digits.';
        break;
      case 'query':
        errors.query = value.length >= 15 ? '' : 'Query should be at least 15 characters long.';
        break;
      default:
        break;
    }

    setFormErrors(errors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    validate(name, value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    Object.keys(formValues).forEach((name) => validate(name, formValues[name]));

    if (Object.values(formErrors).some((error) => error !== '')) {
      setSubmissionError('Please fix the errors in the form.');
      return;
    }

    setSubmitting(true);

    emailjs.send('service_xfjuzx', 'template_fmeei2', formValues, '7whvvYJEvhwHWK7M')
      .then((response) => {
        Swal.fire('Success', 'Email sent successfully!', 'success');
        setSubmitting(false);
        setShowModal(false);
        setFormValues({ name: '', email: '', mobile: '', query: '' });
        setFormErrors({});
        setSubmissionError('');
      })
      .catch((error) => {
        console.log('FAILED...', error);
        setSubmitting(false);
        setSubmissionError('Failed to send email. Please try again.');
        Swal.fire('Error', 'Failed to send email. Please try again later.', 'error');
      });
  };

  return (
    <div className="price-section">
      <div className="left-p">
        
       
      </div>
      <div className="right-p">
        <h3 className="price-list-heading">Price List Iris Broadway Greno West</h3>
        <div className="price-list">
          {[
            { title: ' TYPE A', area: 'AROUND 0000 SQ.FT.', features: ['3 Shops, 3 Toilet, Lobby'], price: 'Price On Demand' },
            { title: ' TYPE B', area: ' AROUND 0000 SQ. FT. ', features: ['2 Shops, 3 Toilet,3 Balcony,Lobby, S-Room, S-Toilet'], price: 'Price On Demand' },
            { title: ' TYPE C', area: ' AROUND 0000 SQ. FT. ', features: ['1 Bedrooms, 1 Toilet, 2 Balcony'], price: 'Price On Demand' },
            { title: ' TYPE D', area: 'AROUND 0000 SQ. FT. ', features: ['4 Shops, 3 Toilet,2 Balcony'], price: 'Price On Demand' },
            
          
          ].map((item, index) => (
            <div key={index} className="price-card">
              <h4>{item.title}</h4>
              <p className="price-area"><FaRuler className='icon-p'/> Area: {item.area}</p>
              <p className="price-features"><GiShop className='icon-p'/> Features: {item.features.join(', ')}</p>
              <button className="enquire-btn" onClick={handleShowModal}>{item.price}</button>
            </div>
          ))}
        </div>
      </div>
      <Modal show={showModal} handleClose={hideModal}>
        <h2 className="modal-heading">Get More Details</h2>
        <form className="modal-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name:</label>
            <input type="text" id="name" name="name" value={formValues.name} onChange={handleChange} className={`input ${formErrors.name ? 'invalid' : ''}`} required />
            {formErrors.name && <span className="error">{formErrors.name}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input type="email" id="email" name="email" value={formValues.email} onChange={handleChange} className={`input ${formErrors.email ? 'invalid' : ''}`} required />
            {formErrors.email && <span className="error">{formErrors.email}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="mobile">Mobile:</label>
            <input type="tel" id="mobile" name="mobile" value={formValues.mobile} onChange={handleChange} className={`input ${formErrors.mobile ? 'invalid' : ''}`} required />
            {formErrors.mobile && <span className="error">{formErrors.mobile}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="query">Your Query:</label>
            <textarea id="query" name="query" value={formValues.query} onChange={handleChange} className={`input ${formErrors.query ? 'invalid' : ''}`} rows="4" required />
            {formErrors.query && <span className="error">{formErrors.query}</span>}
          </div>
          {submissionError && <span className="submission-error">{submissionError}</span>}
          <button type="submit" className="button-3" disabled={submitting}>{submitting ? 'Submitting...' : 'Submit'}</button>
        </form>
      </Modal>
    </div>
  );
};

export default Pricelist;
